import React, {useState, useEffect } from "react"
import _ from "lodash"
import { InputText_s } from "styles/input-styles"
import { localizeNum, tryParseFloat } from "data/lib/numbers"
import { field_attrs } from "components/table/lib/column-field"

interface NumberEditable {
  attrs?: Function,
  data: any,
  default?: number,
  disabled?: boolean,
  disabledText?: string,
  field: string|any[],
  persist: Function,
  className: string,
  min?: number,
  max?: number,
  readPrecision?: number,
  writePrecision?: number,
  trailingZeros?: boolean,
  onKeyDown?: Function
}

const NumberInput = (props: NumberEditable) => {
  const initialValue = _.isNil(_.get(props.data, props.field)) ? props.default : _.get(props.data, props.field)
  const [dirty, updateDirty] = useState<boolean>(false);
  const [val, updateVal] = useState<string>(_.isNil(initialValue) ? "" : localizeNum(initialValue, props.readPrecision, props.trailingZeros))

  function update(): void {
    let parsedVal = val !== "" ? tryParseFloat(val, props.writePrecision) : null
    if(parsedVal) {
      if(_.isNumber(props.min)) parsedVal = Math.max(_.get(props, 'min'), parsedVal)
      if(_.isNumber(props.max)) parsedVal = Math.min(_.get(props, 'max'), parsedVal)
    }

    props.persist(parsedVal, props.field)
    updateVal(parsedVal !== "" ? localizeNum(parsedVal, props.readPrecision, props.trailingZeros) : parsedVal)
    updateDirty(false)
  }

  useEffect(() => {
    if (_.isNil(initialValue) && !_.isNil(val)){
      updateVal("")
    }
    if (!_.isNil(initialValue)) {
      updateVal(localizeNum(initialValue, props.readPrecision, props.trailingZeros))
    }
  }, [initialValue])

  const attrs = props.attrs && props.attrs(props.field) || {}

  const valid = (key) => /^(\d|,|.)$/.test(key) || key === 'Delete' || key === 'Backspace'

  return (
    <InputText_s
      type="text"
      className={props.className}
      disabled={props['disabled']}
      {...attrs}
      value={val}
      onChange={e => updateVal((e.target as HTMLInputElement).value)}
      onKeyDown={e => {
        if (!dirty && valid(e.key)) updateDirty(true);
        switch(e.key) {
          case "Enter":
            updateVal((e.target as HTMLInputElement).value)
            break
          case "Tab":
            updateVal((e.target as HTMLInputElement).value)
            break
        }
        props.onKeyDown ? props.onKeyDown(e) : null
      }}
      onFocus={_e => {
        (!_.isNil(val) && val !== "") ? updateVal(tryParseFloat(val, props.writePrecision)) : val
      }}
      onBlur={_e => {
        (dirty || props.default) ? update() : updateVal(val !== "" ? localizeNum(val, props.readPrecision, props.trailingZeros) : val)
      }}
      placeholder={props.disabled && props.disabledText ? props.disabledText : ''}
    />
  )
}

export default NumberInput
